import React, { useEffect, useRef, useState } from "react";
import "./style.scss";

import {
  Layout,
  Form,
  Input,
  Button,
  message,
  Avatar,
  Upload,
  Image,
  PageHeader,
  Space,
  Menu,
  Tooltip,
} from "antd";
import R2Footer from "../../components/Footer";
import TestimonialService from "../../services/TestimonialService";
import { connect } from "react-redux";
import { withRouter, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, CameraOutlined, EditOutlined, UserOutlined } from "@ant-design/icons";
import { Edit2 } from "react-feather";

const { Content } = Layout;

const MAX_WIDTH = 1920;
const MAX_HEIGHT = 1080;

const MyBusiness = (props) => {
  const formRef = React.createRef();
  const [form] = Form.useForm();

  const [myBusiness, setMyBusiness] = useState();
  const [logo, setLogo] = useState("");
  const [banner, setBanner] = useState("");
  const [cover, setCover] = useState("");
  const [isEdit, setIsEdit] = useState(false)

  const location = useLocation();
  const isFoodLuvTrail = location.pathname
    ?.toString()
    .includes("foodluv-trial");

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const beforeUploadBanner = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const dataUrl = await TestimonialService.uploadPhoto(formData);
   

    
    setBanner(dataUrl.url);
  };

  const beforeUpload = async (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    const formData = new FormData();
    formData.append("file", file);
    const dataUrl = await TestimonialService.uploadPhoto(formData);

    

   
    setLogo(dataUrl.url);
  };

  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  const checkResolution = async(file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new window.Image();

        img.onload = () => {
          const { width, height } = img;
          if (width >= MAX_WIDTH && height >= MAX_HEIGHT) {
            resolve(true);
          } else {
            resolve(false);
          }
        };

        img.onerror = () => {
          resolve(false);
        };

        img.src = e.target.result;
      };

      reader.onerror = () => {
        resolve(false);
      };

      reader.readAsDataURL(file);
    });
  };

  const beforeUploadanner = async (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return false;
    }
    // const isLt2M = file.size / 1024 / 1024 < 2;
    // if (!isLt2M) {
    //   message.error("Image must smaller than 2MB!");
    //   return false;
    // }

    const isResolutionValid = await checkResolution(file);
    if (!isResolutionValid) 
      {
        message.error("Image resolution must be greater than 1920 X 1080");
        return false;
      }
  
    const formData = new FormData();
    formData.append("file", file);
    const dataUrl = await TestimonialService.uploadPhoto(formData);

    
    setBanner(dataUrl.url);
  };
  const handleChange = async (info) => {};

  useEffect(() => {
    getBusiness();
  }, []);
  useEffect(() => {
    console.log(logo)
  }, [logo]);

  useEffect(() => {
    if (myBusiness?.contacts) {
      formRef.current.setFieldsValue({
        name: myBusiness?.name,
        email: myBusiness?.email,
        jobTitle: myBusiness?.contacts[0]?.job_title,
        address: myBusiness?.address,
        phone_number: myBusiness?.phone_number,
      });
      
    }
  }, [formRef, myBusiness]);

  const getBusiness = async () => {
    const restaurant_id = props.adminRestaurant;
    const data = await TestimonialService.getBusiness(restaurant_id);
    setMyBusiness(data);
    setLogo(data.logo_url);
      setBanner(data.banner_url);
      setCover(data.cover_url);
  };
  const addAdmin = async (values) => {
    const restaurant_id = props.adminRestaurant;
    const payload = {
      
        name: values.name,
        phone_number: values.phone_number,
        address: values.address,
        banner_url: banner,
        logo_url: logo
       
    }
    await TestimonialService.updateBusiness(restaurant_id,payload);
    message.success("Updated Successfully");
  };
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <Upload
          className="edit-icon"
          showUploadList={false}
          beforeUpload={beforeUploadBanner}
          onChange={handleChange}
        >
          Change banner
        </Upload>
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader
          className="page-header-business"
            title={
              isFoodLuvTrail ? "Create Business Profile" : 
              !isEdit ?"Business Profile" : <div onClick={()=>setIsEdit(false)} style={{cursor:"pointer"}}><ArrowLeftOutlined/> Edit Business Profile</div>
            }
            extra={[
              !isEdit &&
              <Button
                type="primary"
                icon={<Edit2 size={16} className="mr-8" />}
                className="custom-btn"
                onClick={()=> setIsEdit(true)}
              >
                Edit
              </Button>,
            ]}
          />
          <div className="content-container-business box-shadow-card">
            <div className="banner business-logo">
              {/* <Image src={banner} alt="banner" className="banner-img" height={300} /> */}
              <div
      style={{
        width: "100%",
        height: "300px", // your desired banner height
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5", // optional background behind image
        overflow: "hidden",
      }}
    >
      <Image
        src={banner}
        alt="Banner"
        preview={false}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
        }}
      />
    </div>
              {isEdit &&
            <Tooltip title="For best results, image dimensions should exceed standard HD (1920 x 1080 pixels)." color={"#108ee9"}>

              <Upload
                name="avatar"
                listType="picture-card"
                className="edit-icon"
                showUploadList={false}
                beforeUpload={beforeUploadanner}
                onChange={handleChange}
              >
                <CameraOutlined style={{fontSize:'20px'}}/>
              </Upload>
              </Tooltip>
}
              <div className="edit-logo-image"> 
              <Avatar
                size={100}
                icon={<UserOutlined />}
                src={logo}
                className="logo"
              />
              {isEdit &&
              <Upload
                name="avatar"
                listType="picture-card"
                className="edit-icon"
                showUploadList={false}
                beforeUpload={beforeUpload}
                onChange={handleChange}
              >
                <CameraOutlined style={{fontSize:'20px'}}/>
              </Upload>
}
              </div>
            </div>
              <Form
                ref={formRef}
                form={form}
                onFinish={addAdmin}
                layout="vertical"
                style={{padding:40}}
              >
                <Form.Item
                  name="name"
                  label="Business Name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input disabled={!isEdit}/>
                </Form.Item>

                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>

                <Form.Item
                  name="jobTitle"
                  label="Job Title"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  name="phone_number"
                  label="Phone Number"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input disabled={!isEdit}/>
                </Form.Item>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input.TextArea disabled={!isEdit}/>
                </Form.Item>
                  {isEdit &&
                <Form.Item className="button-form mt-2">
                  <Button  className="custom-btn">
                    cancel
                  </Button>
                  <Button
                    type="primary"
                    className="custom-btn ml-1"
                    htmlType="submit"
                  >
                    Save
                  </Button>
                </Form.Item>
}
              </Form>
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(MyBusiness));
